import React from 'react';

const Loader: React.FC = () => {
  return (
    <div className='fixed top-0 left-0 right-0 bottom-0 z-[111111] bg-black bg-opacity-10 backdrop-blur-[4px]'>
      <div
        className='inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-secondary motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white'
        style={{
          borderTopColor: 'transparent',
          position: 'absolute',
          top: '50%',
          left: '45%',
          // left: "50%",
          height: '50px',
          width: '50px',
          color: '#4a2d1a',
        }}
        role='status'
      >
        <span className='!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]'>
          Loading...
        </span>
      </div>
    </div>
  );
};

export default Loader;
